import { Link, useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import ButtonComponent from "components/button/ButtonComponent";
import TextFieldComponent from "components/input/TextFieldComponent";
import { MESSAGE } from "constants/validate";
import Header from "../../../components/Header";
import useForgotPassword from "../hooks/useForgotPassword";

/**
 *
 */
function ForgotPassword() {
  const navigate = useNavigate();
  const { email, disabledSubmit, setErrors, setEmail, handleSubmit } = useForgotPassword();

  return (
    <>
      <Header showMenu={false} />
      <Box sx={{ px: { xs: 2, md: 2.5, lg: 5 }, pt: { xs: 2, md: 2.5, lg: 3 } }}>
        <Button onClick={() => navigate(-1)} variant="custom-outlined">
          <Box>＜ 戻る</Box>
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 100px)",
          bgcolor: "background.paper",
          p: 3,
        }}
      >
        <img src="/img/login/yhbb_login_top.png" alt="YHBB Login" />
        <Typography
          variant="h2"
          sx={{
            fontSize: "31px",
            paddingTop: "67px",
            fontWeight: "medium",
            color: "var(--gray-700)",
            marginBottom: "50px",
          }}
        >
          パスワードリセット送信画面
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mt: 2,
            width: "100%",
            maxWidth: "760px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "32px",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <TextFieldComponent
              sxBox={{ width: "500px", justifyContent: "flex-end" }}
              title="メールアドレス"
              value={email}
              onChangeText={setEmail}
              sx={{ width: "240px" }}
              type="text"
              validateOption={{
                required: { message: MESSAGE.EMPTY_EMAIL },
                email: { message: MESSAGE.INVALID_EMAIL },
              }}
              onError={(error) => {
                setErrors({ email: error });
              }}
            />
          </Box>
          <ButtonComponent
            disabled={disabledSubmit}
            type="submit"
            label="送信する"
            theme="dark"
            sx={{
              height: "50px",
              marginTop: "83px",
              marginX: "auto",
              width: "240px",
            }}
          />
        </Box>
      </Box>
    </>
  );
}

export default ForgotPassword;
